module.exports = __webpack_public_path__ + "assets/logo.fd76731f.svg";